<template>
  <div id="checkCard">
    <navbar />
    <!-- <v-header></v-header> -->
    <div class="checkCard">
      <div class="content">
        <div class="contentHeader">
          <el-row :gutter="10" style="font-weight:400;color:rgba(51,51,51,1);">
            <el-col :span="8">
              机构号
              <el-input v-model="companyNo" placeholder="请输入机构号" style="width:60%"></el-input>
            </el-col>
            <el-col :span="8">
              保单号
              <el-input v-model="policyNo" placeholder="请输入保单号" style="width:60%"></el-input>
            </el-col>
            <el-col :span="6">
              保全项
              <el-select placeholder="请选择" v-model="edorType">
                  <el-option label="投保人变更" value="21">投保人变更</el-option>
                  <el-option label="生存金受益人变更" :value="'14'">生存金受益人变更</el-option>
                  <el-option label="身故保险金受益人变更" :value="'13'">身故保险金受益人变更</el-option>
                  <el-option label="生存金发放方式变更" :value="'10'">生存金发放方式变更</el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-button class="btnFront" @click="search">筛选</el-button>
                </el-col>
                <el-col :span="10">
                  <el-button class="btnFront" @click="reset">重置</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="contentBody">
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="tableHeaderColor" :cell-style="tableCellStyle" >
            <el-table-column prop="mechanism" label="机构号" ></el-table-column>
            <el-table-column prop="policyNo" label="保单号" ></el-table-column>
            <el-table-column prop="edorType" label="保全项" ></el-table-column>
            <el-table-column prop="date" label="生成时间" ></el-table-column>
            <el-table-column label="操作" >
              <template slot-scope="scope">
                <!-- <el-button @click="down(scope.row)" type="text" size="medium">资料下载</el-button> -->
                <el-button @click="show(scope.row)" type="text" size="medium">资料预览</el-button>
                <el-button @click="submit(scope.row)" type="text" size="medium">已提交</el-button>
                <el-button @click="cancellations(scope.row)" type="text" size="medium">未处理</el-button>
              </template> 
            </el-table-column>
          </el-table>
        </div>
        <div class="contentFooter">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size= "pagesize"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="count">
          </el-pagination>
        </div>
      </div>
      <v-footer></v-footer>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      style="margin-top:-5vh"
      >
      <el-tabs  v-model="activeName" type="">
        <el-tab-pane :label="typeStr+'信息'" name="first" v-if="messgaeUrl">
          <v-pdf :pdfUrl='messgaeUrl' v-if="activeName=='first'" @scroll='scroll' ></v-pdf>
        </el-tab-pane>
        <el-tab-pane :label="typeStr+'影像资料'" name="second" v-if="imagesUrl">
          <v-pdf :pdfUrl='imagesUrl' v-if="activeName=='second'" @scroll='scroll'></v-pdf>
        </el-tab-pane>
        <el-tab-pane label="申请人影像资料" name="third" v-if="applicantUrl">
          <v-pdf :pdfUrl='applicantUrl' v-if="activeName=='third'" @scroll='scroll'></v-pdf>
        </el-tab-pane>
        <el-tab-pane label="被保险人影像资料" name="fourth" v-if="insuredUrl">
          <v-pdf :pdfUrl='insuredUrl' v-if="activeName=='fourth'" @scroll='scroll'></v-pdf>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import vFooter from "@/layout/Footer.vue";
import vHeader from '@/layout/Header.vue'
import Navbar from "@/modules/Navbar";
import url from "@/modules/url.js";
import api from "@/modules/api.js";
import date from '@/filters/date.js'
import { Loading } from "element-ui";
import vPdf from "./components/pdf";
export default {
  name: "pendingList",
  components: {
    vFooter,Navbar,vPdf
  },
  data() {
    return {
      edorType: '',
      policyNo:'',
      companyNo: "",
      tableData: [],
      tableHeight: "100%",
      pagesize: 10,
      currentPage: 1,
      count: 0,
      loadingOpt: {
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      },
      dialogVisible:false,
      activeName:'first',
      typeStr:'',
      edor:'',
      messgaeUrl:'',
      imagesUrl:'',
      applicantUrl:'',
      insuredUrl:'',
      subPolicyNo:'',
    };
  },
  mounted() {
    // this.getParticipants();
    this.$nextTick(() => {
      this.getTableHeight();
    });
    
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  },
  methods: {
    getTableHeight() {
      this.tableHeight = document.querySelector(".contentBody").clientHeight*2;
    },
    getParticipants(a) {
      // this.tableData = []
      // this.count =0
      let req = {
        edorType: this.edorType,
        policyNo: this.policyNo,
        companyNo: this.companyNo,
        currentPage: a||this.currentPage,
        pageSize: 10
      }
      let loadingInstance = Loading.service(this.loadingOpt);
      api.post(url.getNoProcessedOrders, req, (res) => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess) {
          this.count = res.data.count;
          this.tableData = res.data.list.map(item=>{
            item['date']=date.formatDate(item.createDate, 'yyyy-MM-dd hh:mm:ss')
            return item
          })
          this.currentPage=a||this.currentPage
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    search() {
      if(this.companyNo&&!/^[0-9A-Za-z]+$/.test(this.companyNo)){
        this.$message({
          message: '机构号仅支持数字和字母',
          type: 'warning'
        })
      }else if(this.policyNo&&!/^[0-9A-Za-z]+$/.test(this.policyNo)){
        this.$message({
          message: '保单号仅支持数字和字母',
          type: 'warning'
        })
      }else{
        this.currentPage = 1
        this.getParticipants();
      }
    },
    reset() {
      this.edorType=''
      this.policyNo=''
      this.companyNo=''
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "font-weight:bold;color:rgba(211,189,142,1);text-align:center;";
      }
    },
    tableCellStyle({ row, rowIndex }) {
      return "text-align:center;";
    },
    handleCurrentChange(val) {
      this.getParticipants(val);
      document.querySelectorAll(".el-table__body-wrapper")[0].scrollTop = 0;
      document.querySelectorAll(".el-table__body-wrapper")[0].scrollLeft = 0;
    },
    cancellations(val){
      this.$prompt('备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\S]+/,
        inputErrorMessage: '备注必填'
      }).then(({ value }) => {
        let req = {
          remark:value,
          id:val.id
        }
        let loadingInstance = Loading.service(this.loadingOpt);
        api.post(url.cancellation, req, (res) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          if (res.result.isSuccess) {
            this.getParticipants()
          } else {
            if (res.result.errors.length > 0) {
              this.$message(
                res.result.errors[0].errorCode + res.result.errors[0].error
              );
            } else {
              this.$message(res.result.error);
            }
          }
        });
      }).catch(() => {
             
      });

    },
    submit(val){
      let obj={
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9A-Za-z]+$/,
        inputErrorMessage: '仅支持数字和字母输入',
      }
      if(this.subPolicyNo)obj.inputValue=this.subPolicyNo
      this.$prompt('请输入保全号', '提示', obj).then(({ value }) => {
        this.subPolicyNo=value
        let loadingOpt= {
          lock: true,
          text: "正在上传影像资料",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        }
        let loadingInstance = Loading.service(loadingOpt)
        let req = {
          edorCode:value,
          id:val.id,
        }
        api.post(url.alreadySubmitted, req, (res) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });
          if (res.result.isSuccess) {
            this.$message('提交成功');
            this.subPolicyNo=''
            this.getParticipants()
          } else {
            if(res.result.errorCode=='pdf-001'){
              this.$alert(res.result.error, '', {
                confirmButtonText: '确定',
                showClose:false,
                callback: action => {
                  this.submit(val)
                }
              });
            }else{
              this.subPolicyNo=''
              this.$message(res.result.error)
            }
          }
        });
      }).catch(() => {
        this.subPolicyNo=''    
      });

    },

    down(val){
      let req = {
        id:val.id
      }
      let loadingInstance = Loading.service(this.loadingOpt);
      api.post(url.materialDownload, req, (res) => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess) {
          let saveLink = document.createElement("a");
          // saveLink.download = val.edorType+'资料包.zip'
          // saveLink.href = 'data:application/zip;base64,'+res.data
          saveLink.href = res.data
          saveLink.click();
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    show(val){
      this.messgaeUrl=''
      this.imagesUrl=''
      this.applicantUrl=''
      this.insuredUrl=''
      let req = {
        id:val.id
      }
      let loadingInstance = Loading.service(this.loadingOpt);
      api.post(url.materialPreview, req, (res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.result.isSuccess) {
          switch (val.edorType) {
            case '投保人变更':
              this.typeStr= '新投保人';
              break;
            case '生存金受益人变更':
              this.typeStr= '新生存金受益人';
              break;
            case '身故保险金受益人变更':
              this.typeStr= '新身故保险金受益人';
              break;
            case '生存金发放方式变更':
              this.typeStr= '基本';
              break;
          }
          this.dialogVisible=true
          this.imagesUrl=res.data.imagesUrl
          this.messgaeUrl=res.data.messgaeUrl
          this.applicantUrl=res.data.applicantUrl
          this.insuredUrl=res.data.insuredUrl
          this.activeName='first'
          this.edor=val.edorType
          this.scroll()

        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
      
    },
    scroll(){
      this.$nextTick(()=>{
        document.getElementsByClassName('el-tabs__content')[0].scrollTop = 0
      })
    }
  },
};
</script>
<style scoped>
/* #checkCard {
  font-family: PingFang SC;
  height: 100%;
} */
.participant {
  background-color: #f5f6fa;
  padding: 0 25px;
  height: 100%;
}
.content {
  height: calc(100% - 40px);
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(229, 229, 229, 1);
  margin-top: 14px;
}
.contentHeader {
  background: rgba(223, 223, 223, 0);
  border: 1px solid rgba(223, 223, 223, 1);
  margin: 20px 30px 10px;
  padding: 20px 30px;
}
.contentHeader .el-row:last-child {
  padding-bottom: 0px;
}
.el-input__inner {
  height: 35px;
}
.el-input,
.el-select,
.el-date-editor,
.el-cascader {
  width: 70%;
}
.el-row {
  padding-bottom: 32px;
}
.el-col-10{
  text-align: center;
}
.contentHeader .btnFront {
  background: rgba(25, 71, 147, 1);
  color: #fff;
}
.contentBody {
  padding: 0 30px;
  height: calc(100% - 280px);
}
.contentFooter {
  text-align: center;
  margin-top: 10px;
}

#checkCard >>> .el-tabs__content{
  height: 60vh;
  overflow: auto;
}
.card_title{
  display: inline-block;
  text-align: right;
  width: 11.2em;
}
.card_value{
  display: inline-block;
  width: calc(100% - 12em);
  padding: 7px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/infoCollection/pendingList.vue